/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * 年代
 */
export enum UserGeneration {
  _10_ = "10代",
  _20_ = "20代",
  _30_ = "30代",
  _40_ = "40代",
  _50_ = "50代",
  _60_ = "60代以上"
}
